import { LockClosedIcon } from "@heroicons/react/24/solid";
import { PlanUpgradeCTA } from "./plan-upgrade-cta";

type LockedOverlayProps = {
  title: string;
  description: string;
  withCta?: boolean;
};

/**
 * Blurred overlay with a lock icon shown over gated features on the mini/retraction plan.
 */
export function LockedOverlay({
  title,
  description,
  withCta,
}: LockedOverlayProps) {
  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-background/70 backdrop-blur-[1.2px] px-6 text-center">
      <div className="flex h-9 w-9 items-center justify-center rounded-full bg-muted">
        <LockClosedIcon className="h-4 w-4 text-muted-foreground" />
      </div>
      <p className="text-sm font-semibold text-foreground">{title}</p>
      <p className="text-xs text-muted-foreground max-w-sm">{description}</p>
      {withCta && <PlanUpgradeCTA />}
    </div>
  );
}
